import { useEffect } from 'react';

import { useQuickAccess } from './QuickAccessProvider.js';
import type { QuickAccessRecord } from './store.js';

type TrackInput = Omit<QuickAccessRecord, 'kind' | 'at'> | null | undefined;

/**
 * Records a record view in the top-bar "Recent" list whenever the given record becomes
 * available (or its id/label changes). Pass `null` while the record is still loading.
 */
export function useTrackRecent(input: TrackInput): void {
  const { trackRecent } = useQuickAccess();
  const entity = input?.entity;
  const id = input?.id;
  const label = input?.label;
  const path = input?.path;

  useEffect(() => {
    if (!entity || !id || !label || !path) return;
    trackRecent({ entity, id, label, path });
  }, [entity, id, label, path, trackRecent]);
}
